import { post } from '../api';
import { buildErrorResponse } from '../utils/errorUtils';

export const charge = async (payload) => {
  const url = '/token';

  return post(url, payload)
    .then((res) => res && res.data)
    .catch((err) => {
      if (!err.response) {
        throw buildErrorResponse('response error', {
          status_code: '500',
          status_message: 'Network failure, please reload your browser'
        });
      }

      const {response} = err;
      const data = response && response.data;
      const statusCode = data && data.status_code;
      const statusMessage =
        data && (data.status_message || data.error_messages);

      throw buildErrorResponse('response error',
        Object.assign(data || {}, {
          status_code: statusCode
            ? statusCode.toString()
            : response.status.toString(),
          status_message: statusMessage
        })
      );
    });
};
